export default __webpack_public_path__ + "static/media/tile_3.86a297dc.png";